import {User} from './user.entity'

export abstract class UserRepository {
    public abstract getUsers(): Promise<User[]>

    public abstract getUser(id: string): Promise<User>

    public abstract updateUser(id: string, user: User): Promise<User>
}
